export const visit = (vm, at) => {
vm(require("calling-integration-sdk-support/lang/en.lyaml"));
at({ "en": { "calling-remote-common": { "providerMenu": { "header": "Choose a calling provider", "footer": "Explore calling apps", "loadFailedalert": { "title": "Unable to load calling providers.", "content": "Please refresh the page and try again." } } } } });
};